import type { CardHeaderProps} from '@chakra-ui/react'
import { Box, CardHeader, Grid } from '@chakra-ui/react'
import type { ReactNode } from 'react'

import { SectionHeading } from '../Section/SectionHeading'
import { BadgeStep } from '../ui/BadgeStep'

export interface RecapSummaryHeaderProps extends CardHeaderProps {
  number?: number | ReactNode
  asHeading?: boolean
}

export const RecapSummaryHeader = ({
  children,
  number,
  asHeading = true,
  ...rest
}: RecapSummaryHeaderProps) => {
  return (
    <CardHeader sx={{ py: 5 }} {...rest}>
      <Grid
        sx={{ gap: 8, alignItems: 'center', gridTemplateColumns: '2rem auto' }}
      >
        {number && <BadgeStep>{number}</BadgeStep>}
        {!number && <Box></Box>}

        {asHeading && <SectionHeading>{children}</SectionHeading>}

        {!asHeading && children}
      </Grid>
    </CardHeader>
  )
}
